module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step5_Image6.e98a4052.webp";